import { inject, Injectable, signal } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { SKIP_ADMIN_AUTH } from '@cardapio-online/http';
import { OrderPayload } from './cart.models';

interface OrderResponse {
  ok: boolean;
  data?: { id: string };
}

export interface LastOrder {
  orderId: string;
  payload: OrderPayload;
}

@Injectable({ providedIn: 'root' })
export class OrderService {
  private readonly http = inject(HttpClient);
  private readonly publicContext = new HttpContext().set(SKIP_ADMIN_AUTH, true);

  readonly lastOrder = signal<LastOrder | null>(null);

  create(
    payload: OrderPayload,
    options?: { accessToken?: string | null }
  ): Observable<OrderResponse> {
    const headers = options?.accessToken
      ? new HttpHeaders({
          Authorization: `Bearer ${options.accessToken}`,
        })
      : undefined;

    return this.http
      .post<OrderResponse>('/orders', payload, {
        context: this.publicContext,
        headers,
      })
      .pipe(
      tap((res) => {
        if (res.ok && res.data?.id) {
          this.lastOrder.set({ orderId: res.data.id, payload });
        }
      })
    );
  }
}
